export const docksTranslations = {
  en: {
    pageTitle: 'Docks',
    nearestDock: 'Nearest Dock',
    loading: 'Loading Docks...',
    noDocksMemory: 'No dock information in memory - restart the app and try again',
    docksError: 'Problem receiving dock data - checking if there are any in memory',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving the dock data! Please restart the app and try again.',
    okButton: 'Ok',
    calculateDistance: 'Calculate distance between two docks',
    departure: 'Departure',
    arrival: 'Arrival',
    distance: 'Distance: '
  },
  it: {
    pageTitle: 'Attracchi',
    nearestDock: 'Attracco più vicino',
    loading: 'Caricamento Attracchi...',
    noDocksMemory: 'Non sono presenti informazioni sugli attracchi in memoria - riavviare l\'app e riprovare',
    docksError: 'Problema nella ricezione dei dati sugli attracchi - controlliamo se ce ne sono in memoria',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati sugli attracchi! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok',
    calculateDistance: 'Calcola la distanza tra due attracchi',
    departure: 'Partenza',
    arrival: 'Arrivo',
    distance: 'Distanza: '
  }
}; 